module.exports = __webpack_public_path__ + "img/digitalocean-black.c7b0f38c.svg";